// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // https://firebase.google.com/docs/web/setup#available-libraries
// import { getAuth } from "firebase/auth";
// import { getMessaging, onMessage } from "firebase/messaging";
// import { getDatabase } from "firebase/database";
// import { getStorage } from "firebase/storage";

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyApnkf6ZSulBWUntTrFfXylABuBAMCSZe8",
//   authDomain: "indriver-c73c1.firebaseapp.com",
//   databaseURL: "https://indriver-c73c1-default-rtdb.firebaseio.com",
//   projectId: "indriver-c73c1",
//   storageBucket: "indriver-c73c1.firebasestorage.app",
//   messagingSenderId: "38387404130",
//   appId: "1:38387404130:web:3d311b1f0fae021529703b",
//   measurementId: "G-EHXP4HKLC0",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// export const messaging = getMessaging(app);
// export const db = getDatabase(app);
// export const storage = getStorage(app);

// onMessage(messaging, ({ notification }) => {
//   // console.log({notification})
//   if(sessionStorage.getItem("auth")){
//     new Notification("BidNRide", {
//       body: notification.body,
//       icon: '/images/logo.jpg',
//     });
//   }
// });

// src/firebase/index.js

// Import Firebase SDK functions
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyApnkf6ZSulBWUntTrFfXylABuBAMCSZe8",
  authDomain: "indriver-c73c1.firebaseapp.com",
  databaseURL: "https://indriver-c73c1-default-rtdb.firebaseio.com",
  projectId: "indriver-c73c1",
  storageBucket: "indriver-c73c1.appspot.com", // FIXED URL typo
  messagingSenderId: "38387404130",
  appId: "1:38387404130:web:3d311b1f0fae021529703b",
  measurementId: "G-EHXP4HKLC0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export initialized services
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);

// Conditionally export messaging (only if supported)
let messaging = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);

    // Optional: handle foreground messages
    onMessage(messaging, ({ notification }) => {
      if (sessionStorage.getItem("auth")) {
        new Notification("BidNRide", {
          body: notification.body,
          icon: "/images/logo.jpg",
        });
      }
    });
  } else {
    console.warn("Firebase Messaging is not supported in this browser.");
  }
});

export { messaging };

